import { ISelectProps } from '../Select';
import { ISelectActions, TOptionValue } from '../types';
import { useDropdownController } from './useDropdownController';
import { useFocusOptionController } from './useFocusOptionController';
import { useSelectStateController } from './useSelectStateController';

export const useSelectController = (props: ISelectProps<TOptionValue | TOptionValue[]>) => {
  const { open, actions: dropdownActions } = useDropdownController();
  const { focusedIndex, actions: focusOptionActions } = useFocusOptionController({ ...props, open });
  const { selectedItems, selectOption, toggleFocusedOptionState } = useSelectStateController({
    ...props,
    actions: dropdownActions,
    focusedIndex,
  });

  const actions: ISelectActions = {
    ...dropdownActions,
    ...focusOptionActions,
    selectOption,
    toggleFocusedOptionState,
  };

  return { selectedItems, open, focusedIndex, actions };
};
